// src/hooks/useSessionModal.ts
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { showSessionModal, hideSessionModal } from '../store/slices/session/sessionSlice';

const useSessionModal = () => {
  const dispatch = useDispatch();
  const isModalVisible = useSelector((state: RootState) => state.session.isModalVisible);

  const openModal = () => {
    dispatch(showSessionModal());
  };

  const closeModal = () => {
    dispatch(hideSessionModal());
  };

  return {
    isModalVisible,
    openModal,
    closeModal,
  };
};

export default useSessionModal;
